import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { dataHooks } from './constants';
import inputClassFactory from '../inputClassFactory';
import compose from '../../hoc/compose';
import withValidation from '../../hoc/withValidation';
import withBlockOuterScroll from '../../hoc/withBlockOuterScroll';
import displayNames from '../displayNames';
import Tooltip from '../tooltip';
import InputValidationErrorSymbol from '../inputValidationError.svg.js';
import InputValidationSuccessSymbol from '../inputValidationSuccess.svg.js';

function template() {
  return /*#__PURE__*/React.createElement("div", {
    className: this.props.getClassName('input-container') + ' ' + _({
      'input-multiline': true,
      'is-disabled': this.isDisabled(),
      success: this.props.success,
      invalid: this.props.invalidMessage
    }).transform(function (res, value, key) {
      if (value) {
        res.push(key);
      }
    }, []).join(' '),
    "data-aid": this.props.automationId,
    "data-hook": this.props.dataHook,
    onClick: this.props.onClick
  }, /*#__PURE__*/React.createElement("textarea", this.getInputProps()), this.props.invalidMessage ? /*#__PURE__*/React.createElement(Tooltip, {
    isOpen: this.props.tooltipIsOpen,
    content: this.props.invalidMessage,
    shouldTranslate: this.props.shouldTranslate,
    key: "validationErrorSymbol",
    className: "input-validation-icon",
    interactive: this.props.isTooltipInteractive,
    alignment: this.props.tooltipAlignment
  }, /*#__PURE__*/React.createElement("span", {
    "data-hook": dataHooks.errorIndication,
    className: "input-validation-icon-inner"
  }, /*#__PURE__*/React.createElement(InputValidationErrorSymbol, null))) : null, this.props.success ? /*#__PURE__*/React.createElement("span", {
    className: "input-validation-icon",
    key: "validationSuccessSymbol"
  }, /*#__PURE__*/React.createElement("span", {
    className: "input-validation-icon-inner"
  }, /*#__PURE__*/React.createElement(InputValidationSuccessSymbol, null))) : null);
}

var inputComp = inputClassFactory(displayNames.TEXT_INPUT_MULTI_LINE, template, {
  blurOnEnterKey: false,
  shouldBlockOuterScroll: true
});
var HOC = [withValidation, withBlockOuterScroll];
inputComp.propTypes = _.defaults({
  isTooltipInteractive: PropTypes.bool
}, inputComp.propTypes);
export default compose(inputComp, HOC);